export default "__VITE_ASSET__Cs0Ejxkj__"